import React from 'react';
// import PropTypes from 'prop-types';

import {
  ExpandableTableWidget,
} from '../../widgets';

const ErrorCodes = (props) => {
  const {
    tableData: {
      data: {
        headers = [],
        rows = [],
      } = {},
    } = {},
    error = null,
  } = props;

  // console.log(headers, rows);
  // console.log(headers, rows);
  return (
    <div className="dashboard">
      <ExpandableTableWidget input={{ error, data: { headers, rows } }} />
    </div>
  );
};

ErrorCodes.defaultProps = null;

export default ErrorCodes;
